import { createContext, useContext } from "react";
import * as adminClientViewIamApi from "../api/adminClientViewIamApi";

const ClientViewIamApiContext = createContext(adminClientViewIamApi);

export function ClientViewIamApiProvider({ api, children }) {
  return (
    <ClientViewIamApiContext.Provider value={api || adminClientViewIamApi}>
      {children}
    </ClientViewIamApiContext.Provider>
  );
}

export function useClientViewIamApi() {
  return useContext(ClientViewIamApiContext);
}
